import SignIn from "../modules/auth/sign-in";
import SignUp from "../modules/auth/sign-up";
import ForgotPassword from "../modules/auth/forgot-password";
import DemoLogin from "../modules/auth/demo-login";

export const Auth = [
  {
    path: "/sign-in",
    element: <SignIn />,
  },
  {
    path: "/sign-up",
    element: <SignUp />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/demo",
    element: <DemoLogin />,
  },
];
